"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const react_native_1 = require("react-native");
const theme_1 = require("theme");
const services_1 = require("services");
const context_1 = require("components/context");
const constants_1 = require("constants/constants");
const icons_1 = __importDefault(require("constants/icons"));
const react_dropzone_1 = __importDefault(require("react-dropzone"));
const native_1 = require("@react-navigation/native");
const rn_emoji_keyboard_1 = require("rn-emoji-keyboard");
const ModalImage_1 = __importDefault(require("./ModalImage"));
const ModalChatFR = ({ ...rest }, ref) => {
    React.useImperativeHandle(ref, () => ({
        onOpen: () => {
            getChatMessages(true);
        },
    }));
    const authContext = React.useContext(context_1.AuthContext);
    const flatListRef = React.useRef();
    const flatListCurrentOffset = React.useRef(0);
    const imageSource = React.useRef();
    const [showModal, setShowModal] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const currentPage = React.useRef(1);
    const blockRequest = React.useRef(false);
    const lastPage = React.useRef(0);
    const [chatGetResponse, setChatGetResponse] = React.useState();
    const [messages, setMessages] = React.useState([]);
    const getChatMessages = React.useCallback((initial) => {
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            setChatGetResponse(response);
            setMessages(response.data ?? []);
            if (initial) {
                /*setTimeout(() => {
                    flatListRef.current.scrollToEnd({animated: false});
                }, 2000);*/
                /*setTimeout(() => {
                    flatListRef.current.scrollToIndex({
                        index: (response.data?.length ?? 0) - 1,
                        animated: false,
                    });
                }, 200);*/
                setTimeout(() => {
                    //if ((flatListCurrentOffset.current ?? 0) > 0) {
                    flatListRef.current.scrollToOffset({
                        offset: 99999999999,
                        animated: false,
                    });
                    //}
                }, 10);
            }
            else {
                /*setTimeout(() => {
                    flatListRef.current.scrollToEnd({animated: false});
                }, 150);*/
                /*setTimeout(() => {
                    flatListRef.current.scrollToIndex({
                        index: (response.data?.length ?? 0) - 1,
                        animated: false,
                    });
                }, 10);*/
                setTimeout(() => {
                    //if ((flatListCurrentOffset.current ?? 0) > 0) {
                    flatListRef.current.scrollToOffset({
                        offset: 99999999999,
                        animated: false,
                    });
                    //}
                }, 10);
            }
            return () => {
                setMessages([]);
            };
        };
        (0, services_1.doSupportChatGet)({
            params: {
                data: {
                    page: 1,
                },
            },
            callback: {
                onSuccess,
            },
        });
    }, [flatListRef.current]);
    const getMoreChatMessages = () => {
        let nextPage = currentPage.current + 1;
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            setChatGetResponse(response);
            if ((response.data?.length ?? 0) > 0) {
                currentPage.current = nextPage;
                const scrollIndex = (messages.length ?? 1) - 1;
                setMessages(messages => [...(response.data ?? []), ...(messages ?? [])]);
                /*setTimeout(() => {
                    flatListRef.current.scrollToEnd({
                        animated: false,
                    });
                }, 5000);*/
                setTimeout(() => {
                    flatListRef.current.scrollToIndex({
                        index: 9,
                        animated: false,
                    });
                }, 10);
                /*setTimeout(() => {
                    //if ((flatListCurrentOffset.current ?? 0) > 0) {
                    flatListRef.current.scrollToOffset({
                        offset: flatListCurrentOffset.current + 50,
                        animated: false,
                    });
                    //}
                }, 10);*/
            }
            blockRequest.current = false;
        };
        (0, services_1.doSupportChatGet)({
            params: {
                data: {
                    page: nextPage,
                },
            },
            callback: {
                onSuccess,
                onLoading: setLoading,
            },
        });
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        getChatMessages(true);
    }, []));
    const getUserHeaderTitle = () => {
        let userHeader = "";
        if (authContext?.loginData?.uidtipo == constants_1.UserType.SN) {
            chatGetResponse?.data
                ?.filter(item => item.position == "right")
                ?.forEach(item => {
                userHeader = item.splName ?? "";
            });
        }
        else if (authContext?.loginData?.uidtipo == constants_1.UserType.RV) {
            chatGetResponse?.data
                ?.filter(item => item.position == "left")
                ?.forEach(item => {
                userHeader = item.clienteNombre ?? "";
            });
        }
        return userHeader;
    };
    const getUserHeaderImageSource = () => {
        let source = icons_1.default.icUserWithBack;
        if (authContext?.loginData?.uidtipo == constants_1.UserType.RV) {
            chatGetResponse?.data
                ?.filter(item => item.position == "right")
                ?.forEach(item => {
                source = {
                    uri: item.iconUserUrl ?? "",
                };
            });
        }
        else if (authContext?.loginData?.uidtipo == constants_1.UserType.SN) {
            chatGetResponse?.data
                ?.filter(item => item.position == "left")
                ?.forEach(item => {
                source = {
                    uri: item.iconUserUrl ?? "",
                };
            });
        }
        return source;
    };
    const onImagePress = (image) => {
        imageSource.current = {
            uri: image,
        };
        setShowModal(true);
    };
    const renderItem = ({ item }) => {
        /*if (item.position === "right") {
            return <MessageItemRight item={item} />;
        } else {
            return <MessageItemLeft item={item} />;
        }*/
        return <MessageItemLeft item={item} onImagePress={onImagePress}/>;
    };
    return (<>
			<native_base_1.Modal {...rest} size="xl">
				<native_base_1.Modal.Content bg="colorLightGrayishBlue1" h="100%">
					<native_base_1.Modal.CloseButton />
					<native_base_1.Modal.Header px="0" py="0">
						<native_base_1.View style={styles.boxChatHeader}>
							<native_base_1.Image w="40" h="40" borderRadius="50%" style={styles.imgSupportPerson} source={getUserHeaderImageSource()} alt="user"/>
							<native_base_1.View flex="1">
								<native_base_1.Text>{getUserHeaderTitle()}</native_base_1.Text>
								<native_base_1.Text>{/*Centro de sopporte*/}</native_base_1.Text>
							</native_base_1.View>
							<native_base_1.Image source={require("images/ic_close.svg")}/>
						</native_base_1.View>
					</native_base_1.Modal.Header>

					{messages.length <= 0 && <native_base_1.View flex="1"></native_base_1.View>}

					{messages.length > 0 && (<native_base_1.FlatList ref={flatListRef} data={messages ?? []} extraData={messages} key={messages.length} keyExtractor={(item, index) => {
                return item?.id ?? "";
                //return index?.toString() ?? "";
            }} renderItem={renderItem} ListHeaderComponent={() => (<native_base_1.View w="100%" h={isLoading ? 70 : 0}>
									{isLoading && <native_base_1.Spinner w="70" h="70"/>}
								</native_base_1.View>)} getItemLayout={(data, index) => {
                return {
                    length: 80,
                    offset: 80 * index,
                    index,
                };
            }} initialScrollIndex={messages.length - 1} onScrollToIndexFailed={() => {
                flatListRef.current.scrollToEnd({
                    animated: false,
                });
            }} onScroll={e => {
                let paddingToBottom = 3000;
                paddingToBottom += e.nativeEvent.layoutMeasurement.height;
                var currentOffset = e.nativeEvent.contentOffset.y;
                flatListCurrentOffset.current = currentOffset;
                if (currentOffset == 0) {
                    if (!isLoading && currentPage.current < lastPage.current && !blockRequest.current) {
                        blockRequest.current = true;
                        setTimeout(() => {
                            getMoreChatMessages();
                        }, 0);
                    }
                }
            }} px="20" minH="100" contentContainerStyle={{
                paddingVertical: 10,
                flexGrow: 1,
            }}/>)}

					<native_base_1.Modal.Footer bg="white" px="0" py="0">
						<InputChat chatGetResponse={chatGetResponse} getChatMessages={getChatMessages}/>
					</native_base_1.Modal.Footer>
				</native_base_1.Modal.Content>
			</native_base_1.Modal>
			<ModalImage_1.default source={imageSource.current} isOpen={showModal} onClose={() => setShowModal(false)}/>
		</>);
};
const MessageItemRight = ({ item }) => {
    const getImageSource = () => {
        if (item.iconUserUrl) {
            return {
                uri: `${item.iconUserUrl}`,
                width: 40,
                height: 40,
            };
        }
        else {
            return icons_1.default.icUserWithBack;
        }
    };
    return (<native_base_1.HStack justifyContent="flex-end" alignItems="flex-end" mt="18" w="100%" py="5">
			<native_base_1.VStack alignItems="flex-end" flex="1">
				<native_base_1.Text variant="h5" textTransform="capitalize"></native_base_1.Text>
				<native_base_1.Text mt="3" bg="colorVividYellow1" borderRadius="15" borderBottomRightRadius={0} py="10" px="20">
					{item.mensaje ?? ""}
				</native_base_1.Text>
			</native_base_1.VStack>
			<native_base_1.Image ml="10" source={getImageSource()} w="25" h="25" borderRadius={13} resizeMode="cover" alt="user"/>
		</native_base_1.HStack>);
};
const MessageItemLeft = ({ item, onImagePress }) => {
    const getImageSource = () => {
        if (item.iconUserUrl) {
            return {
                uri: item.iconUserUrl,
                width: 40,
                height: 40,
            };
        }
        else {
            return icons_1.default.icUserWithBack;
        }
    };
    return (<native_base_1.HStack alignItems="flex-end" mt="18" py="5" flexDir={item.position == "left" ? "row" : "row-reverse"} justifyContent={item.position == "left" ? "flex-start" : "flex-end"}>
			<native_base_1.Image source={getImageSource()} w="25" h="25" mr={item.position == "left" ? 10 : 0} ml={item.position == "right" ? 10 : 0} borderRadius={13} resizeMode="cover" alt="user"/>
			<native_base_1.VStack flex="1" alignItems={item.position == "left" ? "flex-start" : "flex-end"}>
				<native_base_1.Text variant="h5" textTransform="capitalize">
					{item.position == "right"
            ? item.clienteNombre?.toLowerCase() ?? ""
            : item.splName?.toLowerCase() ?? ""}
				</native_base_1.Text>
				<native_base_1.Text mt="3" style={item.position == "left" ? styles.leftMessageBack : styles.rightMessageBack}>
					{item.mensaje ?? ""}
				</native_base_1.Text>
				{item.attachImage && (<native_base_1.HStack style={item.position == "left" ? styles.leftMessageBack : styles.rightMessageBack} px="5" py="5" mt="3">
						<react_native_1.Pressable onPress={() => onImagePress(item.attachImage ?? "")}>
							<native_base_1.Image source={{ uri: item.attachImage }} w="150" h="100" alt="attach image" mr="10"/>
						</react_native_1.Pressable>

						<native_base_1.Link href={item.attachImage}>
							<native_base_1.Image source={icons_1.default.icDownload} w="15" h="15" m="5"/>
						</native_base_1.Link>
					</native_base_1.HStack>)}
				{item.attachFile && (<native_base_1.HStack mt="3">
						<native_base_1.Link flex="1" href={item.attachFile ?? ""} isUnderlined={false} style={item.position == "left" ? styles.leftMessageBack : styles.rightMessageBack} alignItems="center">
							{item.attachFileName ?? ""}

							<native_base_1.Image source={icons_1.default.icDownload} w="15" h="15" ml="5"/>
						</native_base_1.Link>
					</native_base_1.HStack>
        /*<a href={item.attachFile} target="_blank">
            {item.attachFileName}
        </a>*/
        )}
			</native_base_1.VStack>
		</native_base_1.HStack>);
};
const InputChat = ({ getChatMessages, chatGetResponse }) => {
    const [message, setMessage] = React.useState("");
    const [emojiPickerOpen, setEmojiPickerOpen] = React.useState(false);
    const sendChat = params => {
        const onSuccess = (response) => {
            setMessage("");
            getChatMessages(false);
        };
        (0, services_1.doSupportChatSet)({
            params: {
                data: {
                    headerId: chatGetResponse?.headerId,
                    mensaje: message,
                },
                foto: params?.fileFoto,
                attach: params?.fileAttach,
            },
            callback: {
                onSuccess,
            },
        });
    };
    //files
    const onDropAttach = React.useCallback((acceptedFiles) => {
        sendChat({ fileAttach: acceptedFiles[0] });
    }, []);
    const onDropFoto = React.useCallback((acceptedFiles) => {
        sendChat({ fileFoto: acceptedFiles[0] });
    }, []);
    //
    const dropzoneAttachRef = React.createRef();
    const dropzoneFotoRef = React.createRef();
    return (<native_base_1.VStack w="100%">
			<native_base_1.HStack style={styles.layoutChatBottom} w="100%">
				<native_base_1.View style={styles.layoutChatInput} flex="1">
					{false && (<react_native_1.Pressable onPress={() => setEmojiPickerOpen(true)}>
							<native_base_1.Image style={styles.imgChatInput} source={require("images/ic_emoji.svg")}/>
						</react_native_1.Pressable>)}

					<native_base_1.Input py="10" value={message} onChangeText={text => setMessage(text)} style={styles.inputChat} minW="20" placeholder="Escriba su mensaje" returnKeyType="send" onSubmitEditing={() => sendChat()}/>
					<react_native_1.Pressable onPress={() => {
            //sendChat();
            dropzoneAttachRef.current?.open();
        }}>
						<native_base_1.Image style={[styles.imgChatInput, styles.imgAttach]} source={require("images/ic_attach.svg")}/>
					</react_native_1.Pressable>

					<react_native_1.Pressable onPress={() => dropzoneFotoRef.current?.open()}>
						<native_base_1.Image style={styles.imgChatInput} source={require("images/ic_camera.svg")}/>
					</react_native_1.Pressable>
				</native_base_1.View>

				<react_native_1.Pressable onPress={() => sendChat()}>
					<native_base_1.View p="10">
						<native_base_1.Image w="20" h="20" source={icons_1.default.icSend} style={{
            tintColor: theme_1.Colors.colorGray1,
        }}/>
					</native_base_1.View>
				</react_native_1.Pressable>

				<react_dropzone_1.default ref={dropzoneAttachRef} onDrop={onDropAttach} maxFiles={1} multiple={false}>
					{({ getRootProps, getInputProps, isDragActive }) => (<div {...getRootProps()} style={{ display: "none" }}>
							<input {...getInputProps()}/>
						</div>)}
				</react_dropzone_1.default>

				<react_dropzone_1.default ref={dropzoneFotoRef} onDrop={onDropFoto} maxFiles={1} multiple={false} accept={{ "image/jpg": [".jpg"] }}>
					{({ getRootProps, getInputProps, isDragActive }) => (<div {...getRootProps()} style={{ display: "none" }}>
							<input {...getInputProps()}/>
						</div>)}
				</react_dropzone_1.default>
			</native_base_1.HStack>

			{emojiPickerOpen && (<native_base_1.View h="400" w="100%" overflowY="scroll">
					<rn_emoji_keyboard_1.EmojiKeyboard containerStyles={{
                width: "100%",
            }} onEmojiSelected={emoji => {
                setMessage(message + emoji.emoji);
            }}/>
					{/*
            <EmojiSelector
                onEmojiSelected={emoji => {
                    console.log(emoji);
                    setMessage(message + emoji);
                }}
                columns={15}
            />*/}
				</native_base_1.View>)}
		</native_base_1.VStack>);
};
const styles = react_native_1.StyleSheet.create({
    //chat
    layoutChat: {
        position: "absolute",
        right: 0,
        bottom: 0,
        flexDirection: "row",
        alignItems: "flex-end",
        marginEnd: 40,
        marginBottom: 40,
    },
    containerImgHeadset: {
        padding: 20,
        borderRadius: 40,
        backgroundColor: "black",
    },
    imgHeadset: {
        width: 30,
        height: 30,
        tintColor: theme_1.Colors.colorVividYellow1,
    },
    boxChatHeader: {
        paddingStart: 20,
        paddingRight: 60,
        paddingVertical: 15,
        flexDirection: "row",
        backgroundColor: "white",
        boxShadow: "0px 3px 28px rgba(0,0,0, 0.17)",
        borderRadius: theme_1.Sizes.configRadius,
    },
    imgSupportPerson: {
        marginEnd: 15,
        resizeMode: "cover",
    },
    layoutChatBottom: {
        padding: 15,
        backgroundColor: "white",
        borderBottomEndRadius: theme_1.Sizes.configRadius,
        borderBottomStartRadius: theme_1.Sizes.configRadius,
    },
    layoutChatInput: {
        paddingHorizontal: 15,
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: theme_1.Colors.colorLightGrayishBlue1,
        borderRadius: 40,
    },
    imgChatInput: {
        width: 15,
        height: 15,
    },
    imgAttach: {
        marginEnd: 15,
    },
    inputChat: {
        flex: 1,
        paddingHorizontal: 15,
        borderWidth: 0,
        borderColor: "transparent",
        backgroundColor: "transparent",
    },
    leftMessageBack: {
        backgroundColor: "white",
        borderRadius: 15,
        borderBottomLeftRadius: 0,
        paddingVertical: 10,
        paddingHorizontal: 20,
    },
    rightMessageBack: {
        backgroundColor: theme_1.Colors.colorVividYellow1,
        borderRadius: 15,
        borderBottomRightRadius: 0,
        paddingVertical: 10,
        paddingHorizontal: 20,
    },
});
const ModalChat = React.forwardRef(ModalChatFR);
exports.default = ModalChat;
